<template>
  <div class="offline-table">
    <offline-search-bar
      :search-params="searchData"
      @changeSearchParams="changeSearchParams"
      @search="search"
    ></offline-search-bar>
    <div>
      <el-table
        style="width: 100%"
        size="medium"
        header-row-class-name="supervision-table-header"
        class="is-print-hide"
        border
        :data="tableData"
      >
        <el-table-column label="上传时间" prop="uploadTime"></el-table-column>
        <el-table-column label="处方编号" prop="prescriptionId"></el-table-column>
        <el-table-column label="处方图片">
          <template #default="{ row: { prescriptionId, storeName } }">
            <el-button type="text" @click="viewImage({ prescriptionId })">查看</el-button>
            <el-button type="text" @click="downloadImage({ prescriptionId })">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @handlePage="handlePage"
        v-if="tableData && tableData.length"
        :total="pages.totalCount"
        :current-page="pages.pageNo"
        :page-size="pages.pageSize"
      />
      <image-viewer
        :z-index="2000"
        :initial-index="0"
        v-if="dialogVisible"
        :on-close="closeViewer"
        :url-list="[imgUrl]"
      />
    </div>
  </div>
</template>

<script>
import { shortcuts, download, mapRequestParamsEmpty2Null, getFileSuffix } from '@/util';
import dayjs from 'dayjs';
import offlineSearchBar from './offlineSearchBar';
import pagination from '../pagination';
import { mapGetters } from 'vuex';
import ImageViewer from '@/components/image-viewer';

export default {
  name: 'offline',
  components: {
    ImageViewer,
    offlineSearchBar,
    pagination
  },
  data() {
    return {
      searchData: {
        prescriptionId: '',
        registrationTime: [
          dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      },
      tableData: [],
      pages: { totalCount: 0, pageSize: 20, pageNo: 1 },
      dialogVisible: false,
      imgUrl: ''
    };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.loadMore();
  },
  methods: {
    reset() {
      this.searchData = {
        prescriptionId: '',
        storeName: '',
        registrationTime: [
          dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ]
      };

      this.$refs.searchModal.formInit(this.searchData);
      this.pages.pageNo = 1;
      this.loadMore();
    },
    search() {
      this.pages.pageNo = 1;
      this.loadMore();
    },
    loadMore() {
      const {
        storeId,
        searchData,
        pages: { pageNo, pageSize }
      } = this;
      const params = {
        pageNo,
        pageSize,
        ...searchData
      };
      const [uploadStartTime = null, uploadEndTime = null] = params.registrationTime || [];
      Fetch.getOfflinePrescription(
        mapRequestParamsEmpty2Null({ ...params, storeId, uploadStartTime, uploadEndTime })
      ).then(({ data, totalCount }) => {
        this.pages.totalCount = totalCount;
        this.tableData = data;
      });
    },
    async viewImage({ prescriptionId }) {
      const { storeId } = this;
      const { prescriptionImgUrl } = await Fetch.getPrescriptionImageUrl({
        storeId,
        prescriptionRegistrationId: prescriptionId,
        prescriptionCategory: 1
      });
      this.dialogVisible = true;
      this.imgUrl = prescriptionImgUrl;
    },
    async downloadImage({ prescriptionId }) {
      const { storeId } = this;
      const { prescriptionImgUrl } = await Fetch.getPrescriptionImageUrl({
        storeId,
        prescriptionRegistrationId: prescriptionId,
        prescriptionCategory: 1
      });
      const suffix = getFileSuffix(prescriptionImgUrl);
      download(prescriptionImgUrl, `${prescriptionId}.${suffix}`);
    },
    handlePage(pageNo) {
      this.pages.pageNo = pageNo;
      this.loadMore();
    },
    changeSearchParams({ key, value }) {
      this.searchData[key] = value;
    },
    closeViewer() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped></style>
